import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Contacter ACOMEP sur WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden sm:block max-w-0 overflow-hidden group-hover:max-w-[220px] transition-all duration-500 bg-white border border-slate-200 shadow-lg text-sm font-medium text-slate-800 whitespace-nowrap">
        <span className="block px-4 py-2">Une question ? Écrivez-nous</span>
      </span>
      <span className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] shadow-xl shadow-emerald-600/25 group-hover:scale-105 transition-transform duration-300">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <MessageCircle size={26} className="text-white relative" fill="white" />
      </span>
    </motion.a>
  );
}
